import { useDocuments } from "./useDocumentStorage";
import { usePaymentTier } from "./usePaymentTier";
import { useAppContext } from "./useAppContext";
import { hasMinTier } from "@/shared/utils/tierOrder";

/**
 * Hook to determine if the paywall should be shown before allowing document upload
 *
 * Free users are limited to 10 documents. Once they reach this limit, they must upgrade
 * to premium to upload more documents.
 */
export const FREE_DOCUMENT_LIMIT = 10;

export function useUploadPaywall() {
  const { data, isLoading } = useDocuments();
  const { person } = useAppContext();

  const documentCount = data?.documents?.length ?? 0;

  const { tier, isLoading: isTierLoading } = usePaymentTier(person?.estate_id);
  const hasPaidTier = hasMinTier(tier, "basic");

  const shouldShowPaywall = !isTierLoading && !hasPaidTier && documentCount >= FREE_DOCUMENT_LIMIT;
  const remainingSlots = Math.max(0, FREE_DOCUMENT_LIMIT - documentCount);

  return {
    shouldShowPaywall,
    documentCount,
    isPremium: hasPaidTier,
    isLoading: isLoading || isTierLoading,
    freeDocumentLimit: FREE_DOCUMENT_LIMIT,
    remainingSlots,
  };
}
